/**
 * 🏆 TOURNAMENT CONSTANTS - Tournament-specific business rules and configurations
 */

// Tournament-specific business rules
export const FIGHTS_PER_SEASON_FOR_EACH_USER = 8;

// Tournament-specific configurations
export const TOURNAMENT_DEFAULTS = {
  MIN_SEASONS: 1,
  MAX_SEASONS: 10,
  DEFAULT_SEASONS: 1,
  MAX_GLOBAL_DISPLAYED_USERS: 20,
  GLOBAL_TOURNAMENT_PREFIX: 'FMMA',
} as const;
